<template>
  <div>
    <!-- TrustBox widget - Slider -->
    <div v-if="templateId === '54ad5defc6454f065c28af8b'" class="trustpilot-widget" data-locale="en-US" data-template-id="54ad5defc6454f065c28af8b" data-businessunit-id="62986c2d67f7ac096850d61c" data-style-height="240px" data-style-width="100%" data-theme="light" data-stars="4,5" data-review-languages="en">
      <a href="https://www.trustpilot.com/review/shopvidi.com" target="_blank" rel="noopener">Trustpilot</a>
    </div>
    <!-- End TrustBox widget -->
    <!-- TrustBox widget - Micro TrustScore -->
    <div v-if="templateId === '53aa8807dec7e10d38f59f32'" class="trustpilot-widget" data-locale="en-US" data-template-id="53aa8807dec7e10d38f59f32" data-businessunit-id="62986c2d67f7ac096850d61c" data-style-height="110px" data-style-width="100%" data-theme="light">
      <a href="https://www.trustpilot.com/review/shopvidi.com" target="_blank" rel="noopener">Trustpilot</a>
    </div>
    <!-- End TrustBox widget -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      templateId: ''
    }
  },
  created() {
    this.templateId = this.$route.query.templateId
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/trustpilotWidget.vue